import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-no-data-found',
    imports: [TranslateModule],
    templateUrl: './no-data-found.component.html',
    styleUrl: './no-data-found.component.scss'
})
export class NoDataFoundComponent {
    icon = input<string>('pi pi-folder');
    message = input<string>('NO_DATA_FOUND');
    testId = input<string>('no-data-found');
}
